<template>
  <button
    :aria-controls
    :aria-expanded="isActive"
    aria-haspopup="listbox"
    :aria-label="value ? `${label} ${value}` : label"
    class="text-action-default-hi rounded-full flex h-32 items-center gap-x-4 pl-12 pr-8"
    :class="{
      'bg-static-info-hi hover:bg-static-info-hi-hover': isActive,
      'bg-action-default-mid hover:bg-action-default-mid-hover': !isActive,
    }"
    role="combobox"
  >
    <div
      aria-live="polite"
      class="flex max-w-[172px] items-center gap-x-4"
      role="status"
    >
      <span class="body-2 truncate whitespace-nowrap">{{ label }}</span>
      <span v-if="value" class="body-2-bold truncate">
        {{ value }}
      </span>
      <RevTag v-if="tag" class="shrink-0" :label="tag" variant="info" />
    </div>
    <component :is="icon" />
  </button>
</template>

<script lang="ts" setup>
import type { Component } from 'vue'

import { RevTag } from '@ds/components/Tag'
import { IconChevronDown } from '@ds/icons/IconChevronDown'

withDefaults(
  defineProps<{
    label: string
    value?: string
    tag?: string
    isActive?: boolean
    icon?: Component
    ariaControls?: string
  }>(),
  {
    icon: IconChevronDown,
    value: '',
    tag: undefined,
    ariaControls: '',
  },
)
</script>
